import { AppState, RedirectLoginOptions } from '@auth0/auth0-react';
import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'react';
import { ACCESS_DENIED_ERROR_CODE } from '../../../../constants/error-status-code';
import { navigateToLoginAction } from '../../../../core/usecases/shared/navigate-to-login';
import backendHttpClient, { administrationHttpClient } from '../axios-http-client';
import paymentHttpClient from '../axios-http-client';

const PUBLIC_API_PREFIX = '/public/';
const BEARER_TOKEN_PREFIX = 'Bearer';

export const addAuthorizationInterceptor = (
  dispatch: Dispatch<any>,
  loginWithRedirect: (options: RedirectLoginOptions<AppState>) => Promise<void>,
  getAccessTokenSilently: () => Promise<string>
) => {
  backendHttpClient.interceptors.request.use(async (config) => {
    if (localStorage.getItem('e2e-test') === 'true') {
      console.debug("E2E Cookie found, setting X-Tenant header to E2E")
      config.headers['X-Tenant'] = 'E2E'
    }

    // If the endpoint does not require authentication, do not add 'Authorization' header.
    if (config.url?.includes(PUBLIC_API_PREFIX)) {
      return config;
    }
    try {
      const token = await getAccessTokenSilently();
      config.headers.Authorization = `${BEARER_TOKEN_PREFIX} ${token}`;
      return config;
    } catch (err) {
      dispatch(navigateToLoginAction(loginWithRedirect));
      return Promise.reject({ response: { status: ACCESS_DENIED_ERROR_CODE } } as AxiosError);
    }
  });

  backendHttpClient.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === ACCESS_DENIED_ERROR_CODE) {
        dispatch(navigateToLoginAction(loginWithRedirect));
      }
      return Promise.reject(error);
    }
  );  


  administrationHttpClient.interceptors.request.use(async (config) => {
    if (localStorage.getItem('e2e-test') === 'true') {
      console.debug("E2E Cookie found, setting X-Tenant header to E2E")
      config.headers['X-Tenant'] = 'E2E'
    }

    // If the endpoint does not require authentication, do not add 'Authorization' header.
    if (config.url?.includes(PUBLIC_API_PREFIX)) {
      return config;
    }
    try {
      const token = await getAccessTokenSilently();
      config.headers.Authorization = `${BEARER_TOKEN_PREFIX} ${token}`;
      return config;
    } catch (err) {
      dispatch(navigateToLoginAction(loginWithRedirect));
      return Promise.reject({ response: { status: ACCESS_DENIED_ERROR_CODE } } as AxiosError);
    }
  });

  administrationHttpClient.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === ACCESS_DENIED_ERROR_CODE) {
        dispatch(navigateToLoginAction(loginWithRedirect));
      }
      return Promise.reject(error);
    }
  );  
  
  paymentHttpClient.interceptors.request.use(async (config) => {
    if (localStorage.getItem('e2e-test') === 'true') {
      config.headers['X-Tenant'] = 'E2E'
      console.debug("E2E Cookie found, setting X-Tenant header to E2E")
    }

    // If the endpoint does not require authentication, do not add 'Authorization' header.
    if (config.url?.includes(PUBLIC_API_PREFIX)) {
      return config;
    }
    try {
      const token = await getAccessTokenSilently();
      config.headers.Authorization = `${BEARER_TOKEN_PREFIX} ${token}`;
      return config;
    } catch (err) {
      dispatch(navigateToLoginAction(loginWithRedirect));
      return Promise.reject({ response: { status: ACCESS_DENIED_ERROR_CODE } } as AxiosError);
    }
  });

  paymentHttpClient.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === ACCESS_DENIED_ERROR_CODE) {
        dispatch(navigateToLoginAction(loginWithRedirect));
      }
      return Promise.reject(error);
    }
  );
};
